export enum BusinessError {
	REF_NOT_EXISTS = 'REF_NOT_EXISTS',
	REF_EXPIRED = 'REF_EXPIRED',
	REF_CLOSED = 'REF_CLOSED',
	REG_OUT_OF_RANGE = 'REG_OUT_OF_RANGE',
	CAPTCHA_NOT_VALID = 'CAPTCHA_NOT_VALID',
}
